import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

/** ![gitBranchIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiI+PHJlY3QgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjZmZmIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz48cGF0aCBkPSJNNiAzdjEyIi8+PGNpcmNsZSBjeD0iMTgiIGN5PSI2IiByPSIzIi8+PGNpcmNsZSBjeD0iNiIgY3k9IjE4IiByPSIzIi8+PHBhdGggZD0iTTE4IDlhOSA5IDAgMCAxLTkgOSIvPjwvc3ZnPg==) */
const gitBranchIcon = /*#__PURE__*/jsxs(Fragment, {
  children: [/*#__PURE__*/jsx("path", {
    d: "M6 3v12"
  }), /*#__PURE__*/jsx("circle", {
    cx: 18,
    cy: 6,
    r: 3
  }), /*#__PURE__*/jsx("circle", {
    cx: 6,
    cy: 18,
    r: 3
  }), /*#__PURE__*/jsx("path", {
    d: "M18 9a9 9 0 0 1-9 9"
  })]
});

export { gitBranchIcon };
